var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.medicaments) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicaments), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "align-middle col-md-7"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.repeating) + "\n\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-between m-0"
    }, [(!_vm.deleteMedicamentPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      on: {
        "click": function($event) {
          _vm.removeMedicament(m.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled btn_line-heigh-1"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-md-8"
    }, [(m.electronic_prescription === true) ? _c('small', {
      staticClass: "text_shown"
    }, [_vm._v("ERecept")]) : _c('small', {
      staticClass: "text_shown"
    }, [_vm._v("Papírový")]), _vm._v(" |\n                    "), _c('small', {
      class: m.paid_by_sick === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("hradí pacient")]), _vm._v(" |\n                    "), _c('small', {
      class: m.acute === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("akutní")]), _vm._v(" |\n                    "), _c('small', {
      class: m.family === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("rodina")]), _vm._v(" |\n                    "), _c('small', {
      class: m.separate === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("samostatně")]), _vm._v(" |\n                    "), _c('small', [_vm._v("notifikace: "), _c('span', {
      staticClass: "text_shown"
    }, [_vm._v(_vm._s(m.patient_notification_type))])]), _vm._v(" |\n                    "), _c('small', [_vm._v("platnost: "), _c('span', {
      staticClass: "text_shown"
    }, [_vm._v(_vm._s(m.validity_in_days) + " dní")])])]), _vm._v(" "), _c('td', {
      staticClass: "col-md-4"
    }, [_vm._v("\n                    " + _vm._s(m.note) + "\n                  ")])])]
  }), _vm._v(" "), (_vm.medicaments.length > 0) ? [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('td', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left col-md-3"
  }, [(_vm.medicaments.length > 0) ? _c('button', {
    staticClass: "btn btn-sm btn-success btn_line-heigh-1",
    on: {
      "click": function($event) {
        _vm.generatePrescriptions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" vytvořit recepty")]) : _c('button', {
    staticClass: "btn btn-sm btn-success disabled btn_line-heigh-1"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" vytvořit recepty")])])])] : _vm._e()], 2)])]) : (_vm.medicamentsPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        (žádný lék nebyl přidán)\n    ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-7"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Opak.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bc38102","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/ListMedicament.vue
// module id = 566
// module chunks = 0